/**
 * Live floor activity rail: subscribes to /api/v1/stream/tickets and shows
 * a compact list of recent agent activity. Mounted at the bottom of the
 * Morning Brief (/today) so the operator can see specialists working
 * while they sip their coffee. v0.5.3 AE-023 (was orphaned before).
 */
import { useState } from 'react';
import { useStream } from '../lib/useStream';

interface Item {
  id?: string;
  specialist?: string;
  action?: string;
  mode?: string;
  confidence?: number;
  created_at?: string;
}

const MAX = 8;

export function TicketsRail() {
  const [items, setItems] = useState<Item[]>([]);

  useStream({
    url: '/api/v1/stream/tickets',
    onEvent: ({ event, data }) => {
      if (event !== 'ticket') return;
      const t = data as Item;
      setItems((prev) => {
        const next = [t, ...prev.filter((p) => p.id !== t.id)];
        return next.slice(0, MAX);
      });
    },
  });

  return (
    <div className="card p-3">
      <div className="text-[11px] text-ink-mute uppercase tracking-wide mb-2">live floor</div>
      {items.length === 0 && (
        <div className="text-xs text-ink-dim">waiting for agent activity…</div>
      )}
      <ul className="space-y-1 max-h-48 overflow-y-auto">
        {items.map((t, i) => (
          <li key={t.id ?? i} className="text-[11px] flex justify-between gap-2">
            <span className="font-mono text-ink-mute truncate">
              [{t.specialist ?? '?'}] {t.action ?? ''}
            </span>
            <span
              className={
                t.mode === 'live'
                  ? 'text-bad uppercase'
                  : 'text-ok uppercase'
              }
            >
              {t.mode ?? ''}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
